import { createBlobHelper } from '@wayfinder/blob-api-contract/client';
import * as Config from '../config';

const getBlobClient = async () => {
    const accessToken = await Config.getAccessToken();
    return createBlobHelper({ token: accessToken });
};

/*
 * Makes a call to the blob store to upload the image pixels.
 * @sig uploadPixels :: (Image, String, String) -> BlobId
 */
const uploadPixels = async (image, contentType, entityType) => {
    const client = await getBlobClient();
    const response = await client.putBlob(
        { bucket: `${entityType}.locuslabs.com`, folder: 'poi', type: contentType },
        image,
    );
    return response.body.id;
};

/*
 * Get a blob url from the blob store
 * @sig getBlob :: Image -> URL
 */
const getBlob = async image => {
    const client = await getBlobClient();
    const response = await client.getBlob(image.blobId, {
        bucket: 'img.locuslabs.com',
        folder: 'poi',
    });
    return response.body.data.location;
};

const Blob = {
    uploadPixels,
    getBlob,
};

export { Blob };
